import boostIcon from '@/assets/icons/boost.svg'
import PassportIcon from '@/assets/icons/passport.svg'
import IconCartePayment from '@/assets/icons/carte-payment-v2.svg'
import alertIcon from '@/assets/icons/alert.svg'
import subscriptionIcon from '@/assets/icons/subscription.svg'
import accorCardIcon from '@/assets/icons/accor-card.svg'
import {
  IconCalendar,
  IconAccount,
  IconPadlock,
  IconList,
  IconAdd,
  IconFavorite
} from '@accor/icons'
import type { NavigationMenu } from '@/types/navigation'

export const buildB2cMenu = ({
  hasSubscriptionCard,
  hasCoBrandAirline,
  hasAutoConversion
}: {
  hasSubscriptionCard: boolean
  hasCoBrandAirline: boolean
  hasAutoConversion: boolean
}): NavigationMenu => [
  {
    i18nLabel: 'navigation.section.bookings',
    children: [
      {
        routeName: 'myBookings',
        i18nLabel: 'navigationBar.entry.reservation',
        icon: { svg: IconCalendar },
        tracking: { name: 'booking stay', position: 1, pagename: 'account::bookings' }
      },
      {
        routeName: 'preferences',
        i18nLabel: 'navigation.entry.stayPreferences',
        icon: { svg: IconFavorite },
        tracking: {
          name: 'booking preferences',
          position: 2,
          pagename: 'account::stay preferences'
        }
      }
    ]
  },
  {
    i18nLabel: 'navigation.section.loyalty',
    children: [
      {
        routeName: 'myLoyaltyProgram',
        i18nLabel: 'navigationBar.entry.fidelity',
        icon: { svg: accorCardIcon },
        tracking: {
          name: 'loyalty advantages and status',
          position: 3,
          pagename: 'account::loyalty'
        }
      },
      {
        routeName: 'globalTransactionHistory',
        i18nLabel: 'navigationBar.entry.transactions',
        icon: { svg: IconList },
        tracking: { name: 'loyalty points history', position: 4, pagename: 'account::activity' }
      },
      {
        routeName: 'mySubscriptions',
        i18nLabel: 'navigation.entry.subscriptionCard',
        icon: { svg: subscriptionIcon },
        tracking: {
          name: 'loyalty subscription cards',
          position: 5,
          pagename: 'account::hub subscriptions'
        },
        display: () => hasSubscriptionCard
      },
      {
        url: 'https://permalink.accor.com/loyalty-program/subscription-hub?client=ACCOUNT',
        i18nLabel: 'subscription.navigation.withoutCard',
        icon: { svg: boostIcon },
        tracking: {
          name: 'loyalty unlock more advantages',
          position: 6,
          pagename: 'account::unlock more advantages'
        },
        display: () => !hasSubscriptionCard,
        externalHighlight: true
      },
      {
        routeName: 'myPartners',
        i18nLabel: 'navigation.entry.partners',
        icon: { svg: IconAdd },
        tracking: {
          name: 'loyalty partner benefits',
          position: 7,
          pagename: 'account::your partner benefits'
        },
        display: () => hasCoBrandAirline || hasAutoConversion
      }
    ]
  },
  {
    i18nLabel: 'navigation.section.accountSettings',
    children: [
      {
        routeName: 'my-information',
        i18nLabel: 'navigation.entry.data.all',
        icon: { svg: IconAccount },
        tracking: {
          name: 'account contact details',
          position: 8,
          pagename: 'account::my information'
        }
      },
      {
        routeName: 'credential',
        i18nLabel: 'navigation.entry.credential',
        icon: { svg: PassportIcon },
        tracking: {
          name: 'account travel documents',
          position: 9,
          pagename: 'account::travel documents'
        }
      },
      {
        routeName: 'security-settings',
        i18nLabel: 'navigation.entry.securitySettings',
        icon: { svg: IconPadlock },
        tracking: {
          name: 'account security and connection',
          position: 10,
          pagename: 'account::security settings'
        }
      },
      {
        routeName: 'wallet',
        i18nLabel: 'navigation.entry.paymentCard',
        icon: { svg: IconCartePayment },
        tracking: { name: 'account payment card', position: 11, pagename: 'account::payment cards' }
      },
      {
        routeName: 'newsletter',
        i18nLabel: 'navigation.entry.communication',
        icon: { svg: alertIcon },
        tracking: {
          name: 'account communication preferences',
          position: 12,
          pagename: 'account::profile::newsletters'
        }
      }
    ]
  }
]
